import { httpClient } from '@/services/http/httpClient'

import type {
  FinancialDetails,
  FinancialImpactTypeCreation,
} from '@/tabs/shared/financialImpact/types'

type UpdateFinancialImpactProps = {
  id: string
} & FinancialImpactTypeCreation

export const updateFinancialImpact = async ({
  id,
  ...finance
}: UpdateFinancialImpactProps) => {
  const { data } = await httpClient.put<FinancialDetails>(
    `/ideas/financial-details/update/${id}`,
    finance,
  )

  return data
}
